import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Landing from "./pages/Landing";
import { Login, Register } from "./pages/Auth";
import { ForgotPassword, ResetPassword } from "./pages/PasswordReset";
import Dashboard from "./pages/Dashboard";
import Screener from "./pages/Screener";
import StockDetail from "./pages/StockDetail";
import Backtest from "./pages/Backtest";
import Account from "./pages/Account";
import AdminReview from "./pages/AdminReview";
// Spike Radar retired 2026-02 (unbacktested feature, 0 promotions historically).
import AdminBacktest from "./pages/AdminBacktest";
import AdminEmailConsole from "./pages/AdminEmailConsole";
import AdminDashboard from "./pages/AdminDashboard";
import AdminUsers from "./pages/AdminUsers";
import AdminPortfolio from "./pages/AdminPortfolio";
import AdminBoosters from "./pages/AdminBoosters";
import AdminScreenerBlueprint from "./pages/AdminScreenerBlueprint";
import AdminUniverseBacktest from "./pages/AdminUniverseBacktest";
import AdminEarningsSignal from "./pages/AdminEarningsSignal";
import WinPreview from "./pages/WinPreview";
import WinPage from "./pages/WinPage";
import Settings from "./pages/Settings";
import Portfolio from "./pages/Portfolio";
import TrackRecord from "./pages/TrackRecord";
import MockDark from "./pages/MockDark";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import About from "./pages/About";
import Customers from "./pages/Customers";
import Features from "./pages/Features";
import Pricing from "./pages/Pricing";
import VsStockAlarm from "./pages/VsStockAlarm";
import VsMindfulTrader from "./pages/VsMindfulTrader";
import VsFinviz from "./pages/VsFinviz";
import DisclaimerStrip from "./components/DisclaimerStrip";
import ImpersonationBanner from "./components/ImpersonationBanner";
import CosmosBackdrop from "./components/CosmosBackdrop";

function App() {
  return (
    <AuthProvider>
      <CosmosBackdrop />
      <Toaster position="top-right" richColors theme="dark" />
      <ImpersonationBanner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/track-record" element={<TrackRecord />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/mock/dark" element={<MockDark />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/app" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/app/screener" element={<ProtectedRoute requireRole="subscriber"><Screener /></ProtectedRoute>} />
          <Route path="/app/stock/:symbol" element={<ProtectedRoute><StockDetail /></ProtectedRoute>} />
          <Route path="/app/backtest" element={<ProtectedRoute><Backtest /></ProtectedRoute>} />
          <Route path="/app/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
          <Route path="/app/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute requireRole="admin"><AdminReview /></ProtectedRoute>} />
          <Route path="/admin/dashboard" element={<ProtectedRoute requireRole="admin"><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/users" element={<ProtectedRoute requireRole="admin"><AdminUsers /></ProtectedRoute>} />
          <Route path="/admin/portfolio" element={<ProtectedRoute requireRole="admin"><AdminPortfolio /></ProtectedRoute>} />
          <Route path="/admin/boosters" element={<ProtectedRoute requireRole="admin"><AdminBoosters /></ProtectedRoute>} />
          <Route path="/admin/spike-radar" element={<Navigate to="/admin" replace />} />
          <Route path="/admin/screener-blueprint" element={<ProtectedRoute requireRole="admin"><AdminScreenerBlueprint /></ProtectedRoute>} />
          <Route path="/win-preview" element={<WinPreview />} />
          <Route path="/win/:id" element={<WinPage />} />
          <Route path="/admin/backtests/earnings-signal" element={<ProtectedRoute requireRole="admin"><AdminEarningsSignal /></ProtectedRoute>} />
          <Route path="/admin/backtests/universe-expansion" element={<ProtectedRoute requireRole="admin"><AdminUniverseBacktest /></ProtectedRoute>} />
          <Route path="/admin/backtest" element={<ProtectedRoute requireRole="admin"><AdminBacktest /></ProtectedRoute>} />
          <Route path="/admin/email" element={<ProtectedRoute requireRole="admin"><AdminEmailConsole /></ProtectedRoute>} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/about" element={<About />} />
          <Route path="/customers" element={<Customers />} />
          <Route path="/features" element={<Features />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/vs/stock-alarm" element={<VsStockAlarm />} />
          <Route path="/vs/mindful-trader" element={<VsMindfulTrader />} />
          <Route path="/vs/finviz" element={<VsFinviz />} />
        </Routes>
        <DisclaimerStrip />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
